<div class="comments-wrapper">
  <h3>
    @if (Episode()) {
      @if (ProgramData().seasons.length === 1) {
        دیدگاه‌های {{ ProgramData().program.title }} {{ Episode()!.title }}
      } @else {
        دیدگاه‌های {{ ProgramData().program.title }} {{ handleSeasonTitle() }} {{ Episode()!.title }}
      }
    } @else {
      @if (ProgramData().program.isSolitary) {
        دیدگاه‌های {{ ProgramData().program.title }}
      } @else {
        دیدگاه‌های
        <app-menu-button
          [matMenuTriggerFor]="selectComments"
          class="change-comment-menu-button"
          [Text]="
            selectedSeason() ? selectedSeason()!.title + ' - ' + (selectedSeason() ? selectedEpisode()?.title : '') : ''
          "
          Appearance="accent"
        />
        <mat-menu #selectComments="matMenu" xPosition="before" class="change-comment-menu">
          <h3>
            <span>فصل‌ها</span>
            <app-icon-button [IsButton]="true" Appearance="default" (Click)="(selectComments.close)" Icon="close" />
          </h3>
          <div class="select-season-episode-section">
            <div class="seasons-list">
              @for (season of ProgramData().seasons; track $index) {
                <div class="season-title">
                  <button
                    mat-button
                    (click)="handleSelectSeason($event, season)"
                    [class]="{ 'active-season': selectedSeason()?.id === season?.id }"
                  >
                    <mat-icon>{{ selectedSeason()?.id === season?.id ? "chevron_right" : "chevron_left" }}</mat-icon>
                    <span>{{ season?.title }}</span>
                  </button>
                </div>
              }
            </div>
            <div class="episodes-list">
              @for (episode of episodesOfSelectedSeason(); track $index) {
                <div class="episode-title">
                  <button
                    mat-button
                    (click)="handleSelectEpisode(episode)"
                    [class]="{ 'active-episode': selectedEpisode()?.id === episode.id }"
                  >
                    {{ episode?.title }}
                  </button>
                </div>
              }
            </div>
          </div>
        </mat-menu>
      }
    }
  </h3>
  <div class="comments-section">
    <div class="new-comment">
      @if (tokenService.userInfo()) {
        <app-image-generator
          [src]="tokenService.userInfo()?.activeProfile?.avatar!"
          [name]="tokenService.userInfo()?.activeProfile?.name"
          imageType="square"
        />
      } @else {
        <div class="unauthorized-user">U</div>
      }
      <form class="new-comment-form" (ngSubmit)="submitNewComment()">
        <input [formControl]="newCommentControl" placeholder="نظر خود را با دیگران به اشتراک بگذارید..." />
        <app-icon-button
          class="send-btn"
          Icon="send"
          Appearance="primary"
          [IsButton]="true"
          [Loading]="submitNewCommentStatus()"
        />
      </form>
    </div>
    @if (loadingComments()) {
      <div class="loading-comments">
        <app-loading-spinner />
      </div>
    } @else {
      @if (commentsData().length) {
        <div class="all-comments">
          @for (item of commentsData(); track item) {
            <div class="comment-row">
              <div class="comment-box">
                <div class="comment-user">
                  <span>U</span>
                </div>
                <div class="comment-data">
                  <h4>{{ item.timestamp | jalaliDate: "onlyDate" }}</h4>
                  <div class="comment-data-box">
                    <mat-icon
                      [class]="['sentiment-status', item.sentiment]"
                      [matTooltip]="
                        item.sentiment === 'NEUTRAL' ? 'بی‌سویه' : item.sentiment === 'NEGATIVE' ? 'ناراضی' : 'راضی'
                      "
                      matTooltipPosition="above"
                    >
                      {{
                        item.sentiment === "NEUTRAL"
                          ? "sentiment_neutral"
                          : item.sentiment === "NEGATIVE"
                            ? "sentiment_dissatisfied"
                            : "sentiment_satisfied"
                      }}
                    </mat-icon>
                    <p>{{ item.comment }}</p>
                  </div>
                </div>
              </div>
              <div class="comment-operation">
                <div class="comment-info">
                  <div class="likes-data">
                    <span>{{ item.likes > 0 ? (item.likes | number) + "+" : "" }}</span>
                  </div>
                </div>
                @if (tokenService.userInfo()?.activeProfile?.id === item.profileId) {
                  <app-icon-button
                    [IsButton]="true"
                    class="delete-comment"
                    (Click)="deleteComment(item)"
                    [Loading]="submitDeleteComment() && selectedOperationComment() === item"
                    Icon="delete"
                    Appearance="accent"
                  />
                }
                <app-icon-button
                  [IsButton]="true"
                  (Click)="likeComment(item)"
                  [Loading]="submitLikeComment() && selectedOperationComment() === item"
                  Icon="thumb_up"
                  [IsFillIcon]="item.likedByMe"
                  Appearance="accent"
                />
              </div>
            </div>
            <div class="comment-row-mobile">
              <div class="comment-user">
                <span>U</span>
              </div>
              <div class="comment-data-operation">
                <div class="comment-data">
                  <h4>{{ item.timestamp | jalaliDate: "onlyDate" }}</h4>
                  <div class="comment-operation">
                    <div class="likes-data">
                      <span>{{ item.likes > 0 ? (item.likes | number) + "+" : "" }}</span>
                    </div>
                    @if (tokenService.userInfo()?.activeProfile?.id === item.profileId) {
                      <app-icon-button
                        [IsButton]="true"
                        class="delete-comment"
                        (Click)="deleteComment(item)"
                        [Loading]="submitDeleteComment() && selectedOperationComment() === item"
                        Icon="delete"
                        Appearance="accent"
                      />
                    }
                    <app-icon-button
                      [IsButton]="true"
                      (Click)="likeComment(item)"
                      [Loading]="submitLikeComment() && selectedOperationComment() === item"
                      Icon="thumb_up"
                      [IsFillIcon]="item.likedByMe"
                      Appearance="accent"
                    />
                  </div>
                </div>
                <div class="comment-text-sentiment">
                  <div class="comment-info-sentiment">
                    <mat-icon
                      [class]="['sentiment-status', item.sentiment]"
                      matTooltip="میزان رضایت"
                      matTooltipPosition="above"
                      >{{
                        item.sentiment === "NEUTRAL"
                          ? "sentiment_neutral"
                          : item.sentiment === "NEGATIVE"
                            ? "sentiment_dissatisfied"
                            : "sentiment_satisfied"
                      }}</mat-icon
                    >
                  </div>
                  <p>{{ item.comment }}</p>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
          }
        </div>
      } @else {
        <h3>نظری برای این قسمت ثبت نشده است</h3>
      }
    }
  </div>
</div>
